<template>
  <div>
    <grid-row column-align="left">
      <grid-col col-size="2">
        <h4>{{ $t('health.challenge.type') }}</h4>
      </grid-col>
      <grid-col col-size="2">
        {{ $t('health.challenge.types.' + template.type) }}
      </grid-col>
    </grid-row>

    <grid-row column-align="left">
      <grid-col col-size="2">
        <h4>{{ $t('health.challenge.category') }}</h4>
      </grid-col>
      <grid-col col-size="2">
        {{ template.category != null ? $t('health.challenge.categories.' + template.category) : ''}}
      </grid-col>
    </grid-row>

    <grid-row column-align="left">
      <grid-col col-size="2">
        <h4>{{ $t('health.challenge.description') }}</h4>
      </grid-col>
      <grid-col col-size="3">
        {{ template.description }}
      </grid-col>
    </grid-row>

    <grid-row column-align="left">
      <grid-col col-size="2">
        <h4>{{ $t('health.challenge.descriptionEng') }}</h4>
      </grid-col>
      <grid-col col-size="3">
        {{ template.descriptionEng }}
      </grid-col>
    </grid-row>

    <grid-row column-align="left" v-if="isAccumulatedMode">
      <grid-col col-size="2">
        <h4>{{ $t('health.challenge.resultDescription') }}</h4>
      </grid-col>
      <grid-col col-size="3">
        {{ template.resultDescription }}
      </grid-col>
    </grid-row>

    <grid-row column-align="left" v-if="isAccumulatedMode">
      <grid-col col-size="2">
        <h4>{{ $t('health.challenge.resultDescriptionEng') }}</h4>
      </grid-col>
      <grid-col col-size="3">
        {{ template.resultDescriptionEng }}
      </grid-col>
    </grid-row>

    <h4>{{ $t('health.challenge.formula') }}</h4>
    {{ template.formula }}
    <h4>{{ $t('health.challenge.levels') }}</h4>
    <div
      class="selection-wrapper"
      v-for="(level, index) in template.levels"
      :key="index">
      {{ level.index + 1 }} - {{ level.value }}
    </div>
  </div>
</template>

<script>
import BtnPill from '@/components/shared/buttons/BtnPill';
import LabelSelect from '@/components/shared/forms/LabelSelect';
import Modal from '@/components/shared/dialogs/Modal';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';

export default {
  components: {
    BtnPill,
    LabelSelect,
    Modal,
    GridRow,
    GridCol
  },
  props: {
    template: {
      type: Object
    }
  },
  computed: {
    isAccumulatedMode () {
      return this.template.type === 'accumulated';
    }
  },
  methods: {
    timeFormatter (timestamp) {
      const date = new Date(timestamp * 1000);
      return date.toLocaleDateString('en-GB');
    }
  }
};

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/brand/health/components/challenge/ChallengeTemplateData.vue